module.exports = __webpack_public_path__ + "static/media/dashboard-whatsinthebox.cfb49f55.svg";